import type { Square } from './types';

const FILES = 'abcdefgh';
const BISHOP_DIRS: ReadonlyArray<readonly [number, number]> = [
  [1, 1],
  [1, -1],
  [-1, 1],
  [-1, -1],
];

function toSquare(file: number, rank: number): Square | null {
  if (file < 0 || file > 7 || rank < 0 || rank > 7) return null;
  return `${FILES[file]}${rank + 1}` as Square;
}

/** Squares a bishop can reach on an empty board. */
export function bishopReach(from: Square): Square[] {
  const f = FILES.indexOf(from[0]!);
  const r = Number(from[1]) - 1;
  const out: Square[] = [];
  for (const [df, dr] of BISHOP_DIRS) {
    let nf = f + df;
    let nr = r + dr;
    while (true) {
      const sq = toSquare(nf, nr);
      if (!sq) break;
      out.push(sq);
      nf += df;
      nr += dr;
    }
  }
  return out;
}
